import { Button, Card, Flex } from '@servicetitan/anvil2';
import { useState } from 'react';
import { Form, LoanFormData } from './Form';
import { Display } from './Display';
import { FinancedAmountStore } from './financedAmountStore';
import { SubmitHandler } from 'react-hook-form';
import Edit from '@servicetitan/anvil2/assets/icons/material/round/edit.svg';
import { toNumber } from '@servicetitan/anvil2-react-hook-form';

interface ContainerProps {
    showProviderSelection?: boolean;
    /** Maximum allowed financed amount (e.g., approved loan amount for update offer flow) */
    maxAmount?: number;
}

export const Container = ({ showProviderSelection, maxAmount }: ContainerProps) => {
    const [isEditing, setIsEditing] = useState(false);
    const { setFinancedAmount } = FinancedAmountStore.useStore();

    const onSubmit: SubmitHandler<LoanFormData> = data => {
        setFinancedAmount({
            saleAmount: toNumber(data.saleAmount),
            downPayment: toNumber(data.downPayment),
        });
        setIsEditing(false);
    };
    return (
        <Card style={{ width: '100%' }}>
            {isEditing ? (
                <Flex
                    justifyContent="space-between"
                    sm={{ direction: 'column' }}
                    lg={{ direction: 'row' }}
                    style={{ width: '100%' }}
                >
                    <Form
                        onSubmit={onSubmit}
                        onCancel={() => setIsEditing(false)}
                        showProviderSelection={showProviderSelection}
                        maxAmount={maxAmount}
                    />
                </Flex>
            ) : (
                <Flex justifyContent="space-between" style={{ width: '100%' }}>
                    <Display showProviderSelection={showProviderSelection} />
                    <Flex alignSelf="baseline">
                        <Button
                            onClick={() => setIsEditing(true)}
                            icon={Edit}
                            appearance="ghost"
                            aria-label="Edit Financing Information"
                        />
                    </Flex>
                </Flex>
            )}
        </Card>
    );
};
